import React from "react";

const FilterBarClients = ({
  serviceTypeFilter,
  onServiceTypeChange,
}) => {
  return (
    <div className="flex gap-4 mb-4">
      <select
        className="filter"
        value={serviceTypeFilter}
        onChange={(e) => onServiceTypeChange(e.target.value)}
      >
        <option value="all">Tous les types</option>
        <option value="Développement Web">Développement Web</option>
        <option value="Développement Mobile">Développement Mobile</option>
      </select>
    </div>
  );
};

export default FilterBarClients;
